import { ServiceProvider } from "Service";
import { Configuration } from "Configuration";
import { AppContext } from "./AppContext";
import { ITextBlockArray } from "Entities";
import { Language } from "Service/Client";

/**
 * @hidden
 */
export class ResetPassword {
    public static viewModel: kendo.data.ObservableObject;

    private static showLanguageSelector: boolean;

    private static textBlockCategory = "resetpassword";

    private static container: JQuery;

    private static serviceProvider: ServiceProvider;

    private static appContext: AppContext;

    private static languageDropDown: kendo.ui.DropDownList;
    
    public static initialize(
        container: JQuery,
        showLanguageSelector: boolean,
        defaultLanguage: string,
        uniqueApplicationName: string,
        baseUrl: string
    ): Promise<void> {
        this.textBlockCategory = "resetpassword";
        this.container = container;
        this.showLanguageSelector = showLanguageSelector;

        this.appContext = AppContext.current ?? new AppContext();
        this.appContext.configure({
            UniqueApplicationName: uniqueApplicationName,
        });
        Configuration.baseUrl = baseUrl;
        this.serviceProvider = this.appContext.serviceProvider;

        this.viewModel = kendo.observable({
            TextBlock: null,
            isLoaded: false,
            Languages: [],
            SelectedLanguage: null,
        });
        const usedTextBlocks = [
            "pageTitle",
            "pageDescription",
            "ltrPasswordNew",
            "passwordNew",
            "ltrPasswordNewRepeat",
            "passwordNewRepeat",
            "save",
        ];

        for (const textblock of usedTextBlocks) {
            (<any>this.viewModel)[`getTextBlock${textblock}`] = function () {
                const textBlocks = this.get("TextBlock");
                return AppContext.current.serviceProvider.TextBlock.getChecked(textBlocks, textblock, ResetPassword.textBlockCategory);
            };
        }

        this.viewModel.bind("change", (e: any) => {
            if (e.field == "SelectedLanguage") {
                let languageCode = this.viewModel.get("SelectedLanguage").LanguageCode;
                this.serviceProvider.TextBlock.load(languageCode, `${this.textBlockCategory},login`, false).then((textblocks) => {
                    this.setLanguage(
                        languageCode,
                        textblocks[this.textBlockCategory],
                        this.viewModel.get("Languages"),
                        textblocks["login"]
                    );
                    this.viewModel.set("isLoaded", true);
                    this.container.parent().removeClass("dms-hidden").addClass("animated fadeIn");
                });
            }
        });
        let loadPromise = this.serviceProvider.TextBlock.load(defaultLanguage, `${this.textBlockCategory},login`).then((textblocks) => {
            if (this.showLanguageSelector) {
                this.serviceProvider.Language.get().then((languages) => {
                    this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], languages, textblocks["login"]);
                    let selectedLanguage: Language;
                    for (let i = 0, len = languages.length; i < len; i++) {
                        if (languages[i].LanguageCode == defaultLanguage) {
                            selectedLanguage = languages[i];
                        }
                    }
                    this.viewModel.set("SelectedLanguage", selectedLanguage || languages[0]);
                });
            } else {
                this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], [], textblocks["login"]);
                this.viewModel.set("isLoaded", true);
                this.container.parent().removeClass("dms-hidden").addClass("animated fadeIn");
            }
        });

        kendo.bind(this.container, this.viewModel);
        this.languageDropDown = this.container.find("#input-language").data("kendoDropDownList");
        return loadPromise;
    }

    private static setLanguage(
        language: string,
        textblocks: ITextBlockArray,
        languages: Language[],
        textblocksLogin: ITextBlockArray
    ): void {
        for (let i = 0, len = languages.length; i < len; i++) {
            let tbName = "language" + languages[i].LanguageCode;
            languages[i].LanguageDescription =
                this.serviceProvider.TextBlock.getChecked(textblocksLogin, tbName, this.textBlockCategory) ||
                languages[i].LanguageDescription;
        }
        if (this.showLanguageSelector) {
            this.viewModel.set("Languages", languages);
            if (this.languageDropDown) {
                this.languageDropDown.refresh();
            }
        }
        this.viewModel.set("TextBlock", textblocks);
        document.title = textblocks["pageTitle"];
    }
}
